(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('home', {
            parent: 'app',
            url: '/?week&month&year&showChart&vdr&vdoCoo&vdo',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('dashboard');
                    $translatePartialLoader.addPart('dashboardParams');
                    $translatePartialLoader.addPart('calendar');
                    return $translate.refresh();
                }]
            }
        })
        .state('dashboard', {
            parent: 'app',
            url: '/dashboard',
            data: {
                authorities: []
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/metabase-dashboard/metabase-dashboard.html',
                    controller: 'MetabaseDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                currentUser: ['Principal', 'User', function(Principal, User) {
                    return Principal.identity();
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
